const DatatableStyles = {
  table: {
    style: {
      border: "1px solid #e3e6f0",
      fontFamily: "'Public Sans', sans-serif",
    },
  },
  
  headCells: {
    style: {
      border: "1px solid #e3e6f0",
      borderBottom: "2px solid #e3e6f0",
      borderTop: "1.5px solid #e3e6f0",
      color: "#566a7f",
      fontSize: "17px",
      fontWeight: "700",
      textAlign: "center", 
      justifyContent: "center",
      padding: "12px 5px 12px 5px",
      whiteSpace: "normal", 
      wordBreak: "break-word",
    },
  },
  rows: {
    style: {
      minHeight: "30px",
    },
  },
  cells: {
    style: {
      padding: "12px 5px 12px 5px",
      border: "1px solid #e3e6f0",
      color: "#566a7f",
      fontSize: "16px",
      whiteSpace: "normal", 
      wordBreak: "break-word",
    },
  },
};
export default DatatableStyles;
export const scrollableTableContainer = {
  overflowX: "auto",
  width: "100%",
};

